// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip-container {
  max-width: 316px;
}

.tooltip-title {
  color: #323232;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}

.tooltip-description {
  color: #323232;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/components/tooltip/Tooltip.scss","webpack://./src/components/tooltip/Tooltip.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;ACClB;;ADEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;ACCrB;;ADEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;ACCnB","sourcesContent":[".tooltip-container {\n  max-width: 316px;\n}\n\n.tooltip-title {\n  color: #323232;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.tooltip-description {\n  color: #323232;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n}",".tooltip-container {\n  max-width: 316px;\n}\n\n.tooltip-title {\n  color: #323232;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: normal;\n}\n\n.tooltip-description {\n  color: #323232;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
